import styled from "styled-components";
import { ButtonSettings, Text } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const ButtonStyled = styled(ButtonSettings)`
  ${props =>
    props.displayBlock &&
    `
    display: block;
    margin: auto;
    ${props.isMarginTop &&
      `margin-top: ${
        props?.forVerticalSideModal
          ? props.theme.spacing.xsmall
          : props?.customMarginTop
          ? props?.customMarginTop
          : props.theme.spacing.medium
      }`};
    width: ${props.isWidthIncrease ? "42rem" : props?.forVerticalSideModal ? "100%" : "35rem"};
  `}
  &&& {
    ${props => props.lang === "fr" && `letter-spacing: 0.1px`};
    ${props => props.noborder && `border: 0`};
  }
  ${props => props.isLangBtn && `text-align:left;`}
  ${props => props.customWidth && `width:${props.customWidth};`}
  ${props =>
    props.isModalCloseBtn &&
    `width: 15rem;
    height: 2.8rem;
    font-size: 1.2rem;
    line-height: 1;
    position: absolute;
    bottom: 2rem;
    left: calc(50% - 7.5rem);
    `}
  ${props => props.customCSS && props.customCSS}
`;

export const LogoStyled = styled.div`
  margin-bottom: 0.67em;
  ${props => `text-align: ${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right"}`};
`;

export const QRCodeWrapper = styled.div`
  width: 20vw;
  height: 20vw;
  border: 1.25rem solid #fff;
  border-radius: ${props => props.theme.spacing[props.border]};
  margin: 4rem auto;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const TextStyled = styled(Text)`
  margin-top: 2rem;
`;

export const LoginSeparator = styled(Text)`
  margin: 0.8rem 0.2rem;
  font-size: 1.3rem;
  letter-spacing: 0;
  line-height: 1.625rem;
  text-align: center;
  display: flex;
  align-items: center;
  &::after {
    content: "";
    flex: 1 1 auto;
    height: 2px;
    width: 17%;
    display: inline-block;
    margin-left: 0.8rem;
    background-color: rgba(255, 255, 255, 0.1);
  }
  &::before {
    content: "";
    flex: 1 1 auto;
    height: 2px;
    width: 17%;
    display: inline-block;
    margin-right: 0.8rem;
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

export const ChampionsTrophySubscriptionDetail = styled.div`
  display: flex;
  margin-top: ${props => props.theme.spacing.large};
  align-items: center;
`;

export const CTDetailLogo = styled.img`
  height: 2.25rem;
`;

export const CTSubscriptionDetailText = styled(Text)`
  font-size: 0.8rem;
  margin-left: ${props => props.theme.spacing.xxsmall};
  margin-bottom: 0;
`;
